import axios from 'axios'
import * as translationUtils from '../common-utils/translation_utils'

/**
 * Get Order Report
 * @param {MainWrapper} callingClass 
 * @param {string} apiUrl 
 * @param {string} authToken 
 */
export default function getOrderReport(apiUrl, authToken){
    axios(apiUrl,{
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization' : authToken
        }
      }).then(
          (result)=>{
            console.log(result);
            if(result.data.path!=="No Records Found"){
            let response = result.data;
            window.loader(false);
            console.log(response);
            const link = document.createElement('a');
            link.href = response.path;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            }else{
              alert(translationUtils.getTranslation(1478,'No Result(s) Found'));
            }
          }).catch(
            (error)=>{
              console.log(error);
              if(error.response!==undefined && error.response.status===403){
                window.sessionStorage.removeItem('token');
                error.message = "Auth Token Expired, Wait Till Reload";
                //callingClass.setResultdata([],true);
              }else{
                  //callingClass.setResultdata(translationUtils.getTranslation(1478, 'No Result Found'),false);
              }
            }
          );}